import {useRoute} from '@react-navigation/native';
import {useEffect, useState} from 'react';

// useful funciton to get navigation params
// and handle use cases and reduce lines of code
const useParams = () => {
  const navigationState = useRoute();

  // getting initial navigation params
  const [params, setParams] = useState(navigationState?.params || {});

  // handling naviagtion to same controller
  useEffect(() => {
    if (navigationState?.params) {
      setParams(navigationState?.params);
    }
  }, [navigationState?.params]);

  return params;
};

export default useParams;
